import { h } from './dom.js';

// Demo auth (cp-api RFC §5.6): username and password; cp-api sets the HttpOnly session cookie.
export function showLogin(root, api, { message } = {}) {
  return new Promise((resolve) => {
    const error = h('div.login-error', { role: 'alert' }, message ?? '');
    const username = h('input', { name: 'username', autocomplete: 'username', required: true, autofocus: true });
    const password = h('input', { name: 'password', type: 'password', autocomplete: 'current-password', required: true });
    const submit = h('button', { type: 'submit' }, 'Sign in');
    const form = h('form.login', {
      onsubmit: async (e) => {
        e.preventDefault();
        submit.disabled = true;
        error.textContent = '';
        try {
          const session = await api.login(username.value.trim(), password.value);
          resolve(session);
        } catch (err) {
          error.textContent = err.status === 401 ? 'Wrong username or password.'
            : err.status === 429 ? `Too many attempts. Try again in ${err.retryAfter ?? 60} s.`
              : err.message;
          password.value = '';
          password.focus();
        } finally {
          submit.disabled = false;
        }
      },
    },
    h('h1', 'Blast+ Creator'),
    h('label', 'Username', username),
    h('label', 'Password', password),
    submit,
    error);
    root.replaceChildren(h('div.login-page', form));
  });
}
